import {
  ESAProjectExportable,
  ESAProjectReportType,
  PageAction,
} from 'spw-redux/modules/reports/types';

export const REPORT_TYPES: {
  [key: string]: ESAProjectReportType;
} = {
  OCCUPANCY_AND_UTILIZATION: 'occupancyAndUtilization',
  PROGRAM_SUMMARY: 'programSummary',
};

export const PROJECT_EXPORTABLE: { [key: string]: ESAProjectExportable } = {
  PROGRAM_SUMMARY: 'programSummary',
  OCCUPANCY_AND_UTILIZATION_CARDS: 'occupancyAndUtilizationCards',
};

export enum PROGRAM_SUMMARY_CARDS {
  PROJECT_OVERVIEW = 'projectOverview',
  KEY_DATA_POINTS = 'keyDataPoints',
  SPACE_TYPE_ALLOCATION_IWS_USF = 'spaceTypeAllocationIndividualWorkspacesUsf',
  SPACE_TYPE_ALLOCATION_SUBTOTAL_USF = 'spaceTypeAllocationSubtotalUsf',
  HEADCOUNT_USF = 'headcountUsf',
  SEAT_COUNT_USF = 'seatCountUsf',
  DESK_SHARING_RATIO = 'deskSharingRatio',
  USF_BREAKDOWN = 'usfBreakdown',
  MEETING_SEATS_RATIO = 'meetingSeatRatio',
}

export enum ALTERNATIVE_WORKPOINTS_CARDS {
  WORKPOINTS = 'workpoints',
  SEAT_COUNT_USF_WITH_WORKPOINTS = 'seatCountUsfWithWorkpoints',
  DESK_SHARING_WITH_WORKPOINTS = 'deskSharingWithWorkpoints',
  ALTERNATIVE_WORKPOINTS_BREAKDOWN = 'alternativeWorkpointsBreakdown',
}

export const PROGRAM_SUMMARY_CARD_WIDTH: Record<string, number> = {
  projectOverview: 482,
  keyDataPoints: 240,
  spaceTypeAllocationIndividualWorkspacesUsf: 361,
  spaceTypeAllocationSubtotalUsf: 361,
  headcountUsf: 240,
  seatCountUsf: 240,
  deskSharingRatio: 240,
  usfBreakdown: 361,
  meetingSeatRatio: 361,
  workpoints: 240,
  seatCountUsfWithWorkpoints: 240,
  deskSharingWithWorkpoints: 240,
  alternativeWorkpointsBreakdown: 720,
  usfMix: 720,
  seatMix: 720,
  ratios: 720,
};

const clickShowCardsAction: PageAction = {
  action: 'CLICK',
  selector: '#show-cards',
};

export const PROGRAM_SUMMARY_CARD_ACTIONS: Record<string, PageAction[]> = {
  projectOverview: [
    clickShowCardsAction,
    { action: 'CLICK', selector: '#projectOverview' },
  ],
  keyDataPoints: [
    clickShowCardsAction,
    { action: 'CLICK', selector: '#keyDataPoints' },
  ],
  spaceTypeAllocationIndividualWorkspacesUsf: [
    clickShowCardsAction,
    {
      action: 'CLICK',
      selector: '#spaceTypeAllocationIndividualWorkspacesUsf',
    },
  ],
  spaceTypeAllocationSubtotalUsf: [
    clickShowCardsAction,
    {
      action: 'CLICK',
      selector: '#spaceTypeAllocationSubtotalUsf',
    },
  ],
  headcountUsf: [
    clickShowCardsAction,
    {
      action: 'CLICK',
      selector: '#headcountUsf',
    },
  ],
  seatCountUsf: [
    clickShowCardsAction,
    {
      action: 'CLICK',
      selector: '#seatCountUsf',
    },
  ],
  deskSharingRatio: [
    clickShowCardsAction,
    {
      action: 'CLICK',
      selector: '#deskSharingRatio',
    },
  ],
  usfBreakdown: [
    clickShowCardsAction,
    {
      action: 'CLICK',
      selector: '#usfBreakdown',
    },
  ],
  meetingSeatRatio: [
    clickShowCardsAction,
    {
      action: 'CLICK',
      selector: '#meetingSeatRatio',
    },
  ],
  workpoints: [
    clickShowCardsAction,
    {
      action: 'CLICK',
      selector: '#workpoints',
    },
  ],
  seatCountUsfWithWorkpoints: [
    clickShowCardsAction,
    {
      action: 'CLICK',
      selector: '#seatCountUsfWithWorkpoints',
    },
  ],
  deskSharingWithWorkpoints: [
    clickShowCardsAction,
    {
      action: 'CLICK',
      selector: '#deskSharingWithWorkpoints',
    },
  ],
  alternativeWorkpointsBreakdown: [
    clickShowCardsAction,
    {
      action: 'CLICK',
      selector: '#alternativeWorkpointsBreakdown',
    },
  ],
  programSummaryReport: [
    clickShowCardsAction,
    {
      action: 'CLICK',
      selector: '#programSummaryReport',
    },
    {
      action: 'WAIT_FOR_HIDDEN_STATE',
      selector: '.MuiList-root',
    },
  ],
};
